import { Row, Col, Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { isValid } from '../../../utils/utilities';
import { DropPointForm } from './drop-point-form.component';
import { getDropPointCities } from './drop-points.module';
import { useDispatch } from 'react-redux'
import { getAddressLocations } from '../../../actions/trip-create.actions';
import { DropPointTable } from './drop-point-table.component';
import './drop-points.style.scss';

const { Content } = Layout;

export const DropPointComponent = (props) => {

  const {
    routes,
    selectedTrip,
    dropPoints,
    isRowClickEnabled,
    showDeleteUpdateButtons,
    dropPointsLoading
  } = props;
  const {
    id
  } = selectedTrip;

  const dispatch = useDispatch();
  const [dropFormData, setDropFormData] = useState({});
  const [dropAddressLocations, setDropAddressLocations] = useState([]);

  useEffect(() => {
    if (isValid(routes)) {
      dispatch(getAddressLocations(getDropPointCities(routes), false, (data) => { setDropAddressLocations(data.addressLocations) }, () => { }));
    }
  }, [routes]);

  return (
    <Layout className="drop-points-layout">
      <Content>
        <Row type='flex' justify="space-around" className="drop-points-row">
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="drop-points-form-col">
            <DropPointForm
              tripId={id}
              dropAddressLocations={dropAddressLocations}
              dropFormData={dropFormData}
              setDropFormData={setDropFormData}
              isRowClickEnabled={isRowClickEnabled}
              showDeleteUpdateButtons={showDeleteUpdateButtons}
              dropPoints={dropPoints}
              selectedTrip={selectedTrip}
              routes={routes}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={16} className="drop-points-table-col">
            <DropPointTable
              dropPointsLoading={dropPointsLoading}
              dropPoints={dropPoints}
              dropFormData={dropFormData}
              setDropFormData={setDropFormData}
              isRowClickEnabled={isRowClickEnabled}
              showDeleteUpdateButtons={showDeleteUpdateButtons}
            />
          </Col>
        </Row>
      </Content>

    </Layout>

  );
};